export default __webpack_public_path__ + "static/media/IncredibleAnimalsSpeeders_05.ea15ed4b.png";